import { render, staticRenderFns } from "./RequestPasswordRecovery.vue?vue&type=template&id=78783507&"
import script from "./RequestPasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordRecovery.vue?vue&type=script&lang=js&"
import style0 from "./RequestPasswordRecovery.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports